@file:OptIn(ExperimentalCoroutinesApi::class)

package nl.volleyplanner.web.component

import kotlinx.coroutines.Deferred
import kotlinx.coroutines.ExperimentalCoroutinesApi
import kotlinx.coroutines.async
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.SharingStarted
import kotlinx.coroutines.flow.StateFlow
import kotlinx.coroutines.flow.asStateFlow
import kotlinx.coroutines.flow.filterNotNull
import kotlinx.coroutines.flow.first
import kotlinx.coroutines.flow.flatMapLatest
import kotlinx.coroutines.flow.stateIn
import kotlinx.html.*
import kotlinx.html.js.onChangeFunction
import nl.volleyplanner.api.entities.OrganisationSeason
import nl.volleyplanner.web.CoroutineManager
import nl.volleyplanner.web.CoroutineManager.RENDER_SCOPE
import nl.volleyplanner.web.base.HTMLComponent
import nl.volleyplanner.web.base.spinner
import nl.volleyplanner.web.launchAsync
import nl.volleyplanner.web.service.WebUserAndOrganisationService
import org.w3c.dom.HTMLElement
import org.w3c.dom.HTMLSelectElement

class SeasonSelectionComponent : HTMLComponent() {
    private val _selectedSeasonFlow = MutableStateFlow<OrganisationSeason?>(null)
    val selectedSeasonFlow = _selectedSeasonFlow.asStateFlow()

    // TODO: Move all season state management to this component instead of root application
    val selectedSeason: Deferred<OrganisationSeason>
        get() = RENDER_SCOPE.async {
            if (selectedSeasonFlow.value == null) {
                val activeSeason = WebUserAndOrganisationService.selectedOrganisationState
                    .filterNotNull()
                    .flatMapLatest { it.activeSeason }
                    .filterNotNull()
                    .first()
                _selectedSeasonFlow.value = activeSeason
            }

            selectedSeasonFlow.value!!
        }

    init {
        launchAsync(RENDER_SCOPE) {
            WebUserAndOrganisationService.selectedOrganisationState
                .filterNotNull()
                .flatMapLatest { it.activeSeason }
                .filterNotNull()
                .first()
        }.onComplete {
            _selectedSeasonFlow.value = it
        }
    }

    override fun render(consumer: TagConsumer<HTMLElement>): HTMLElement {
        val organisationSeasons = WebUserAndOrganisationService.selectedOrganisationState
            .value?.availableSeasons?.value
        return consumer.div {
            classes += "mb-3"

            if (organisationSeasons == null) {
                spinner()
            } else {
                if (!organisationSeasons.contains(_selectedSeasonFlow.value)) {
                    _selectedSeasonFlow.value = organisationSeasons.last()
                }
                if (organisationSeasons.size == 1) {
                    classes += "d-none"
                }

                label {
                    htmlFor = "season-select"
                    classes = setOf("form-label")
                    +"Seizoen"
                }

                select {
                    id = "season-select"
                    classes = setOf("form-select")

                    onChangeFunction = { event ->
                        val selectElement = event.target as HTMLSelectElement
                        val selectedValue = selectElement.value

                        _selectedSeasonFlow.value = organisationSeasons.find { it.name == selectedValue }!!
                    }

                    // Generate options from the list
                    organisationSeasons.forEach { season ->
                        option {
                            selected = season == _selectedSeasonFlow.value

                            value = season.name
                            +season.name
                        }
                    }
                }
            }
        }

    }

    @OptIn(ExperimentalCoroutinesApi::class)
    override suspend fun getState(): StateFlow<*> = WebUserAndOrganisationService.selectedOrganisationState
        .filterNotNull()
        .flatMapLatest { it.availableSeasons.subscribe() }
        .stateIn(CoroutineManager.RENDER_SCOPE, SharingStarted.Eagerly, null)
}

